import { render } from "./ClientStepWizard.vue?vue&type=template&id=aab2725c&scoped=true"
import script from "./ClientStepWizard.vue?vue&type=script&lang=js"
export * from "./ClientStepWizard.vue?vue&type=script&lang=js"

import "./ClientStepWizard.vue?vue&type=style&index=0&id=aab2725c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab2725c"]])

export default __exports__